import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet';
import { useStore } from '../../Stores/store'
import EventForm from './EventForm/EventForm';
import EventTable from './EventForm/EventTable';
import NewsTable from './NewsForm/NewsTable';
import './Management.css'
import NewsForm from './NewsForm/NewsForm';
import ConfirmEventDeleteModal from './EventForm/ConfirmEventDeleteModal';
import ConfirmNewsDeleteModal from './NewsForm/ConfirmNewsDeleteModal';
import LogInForm from './LogInForm/LogInForm';
import RegisterForm from './RegisterForm/RegisterForm';
import PictureGallery from './PictureForm/PictureGallery';
import PhotoUploadWidget from '../../Core/ImageUpload/PhotoUploadWidget';
import PosterPreview from './PosterPreview/PosterPreview';
import DocumentForm from './DocumentForm/DocumentForm';
import DocumentTable from './DocumentForm/DocumentTable';
import CategoryTable from './CategoryForm/CategoryTable';
import CategoryForm from './CategoryForm/CategoryForm';

export default observer(function Management() {
    const { generalStore, managementStore, categoryStore } = useStore();
    const { haveNewsAndEvents, getNewsAndEvents, updateHaveNewsAndEvents, setIsManagement } = generalStore;
    const { isRegistering, setIsRegistering, getPictures, haveGalleryPictures, haveDocuments, getDocuments } = managementStore;
    const { haveCategories, getCategories } = categoryStore;

    useEffect(() => {
        if(managementStore.token){
            setIsRegistering(false);
            setIsManagement(true);
            if(!haveNewsAndEvents){
                getNewsAndEvents();

                updateHaveNewsAndEvents(true);
            }

            if(!haveGalleryPictures){
                getPictures();
            }

            if(!haveDocuments) {
                getDocuments();
            }

            if(!haveCategories){
                getCategories();
            }
        }
    }, [
        getCategories,
        getDocuments,
        getNewsAndEvents,
        getPictures,
        haveCategories,
        haveDocuments,
        haveGalleryPictures,
        haveNewsAndEvents,
        managementStore.token,
        setIsManagement,
        setIsRegistering,
        updateHaveNewsAndEvents
    ]);

    if(!managementStore.token) {
        return (
            <div className="bg-white/90 w-4/5 mx-auto flex justify-center py-10">
                <div className="flex flex-col items-center w-full max-w-sm gap-6">
                    {isRegistering === false ? <LogInForm /> : <RegisterForm />}
                    <button
                        onClick={() => setIsRegistering(!isRegistering)}
                        className="text-sm text-gray-500 hover:text-gray-800 underline underline-offset-2 transition-colors bg-transparent border-0 cursor-pointer"
                    >
                        {isRegistering ? "Back to Login" : "Register"}
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div >
            <Helmet>
                <title>Management</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <PosterPreview />
            <div className="bg-white/90 w-[90%] mx-auto my-[3%] flex flex-col sm:flex-row justify-start sm:justify-around">
                <div className="w-[95%] mx-auto mb-12 border-b border-gray-400 sm:w-2/5 sm:mb-0 sm:border-b-0 p-[3%]">
                    <h2>Events</h2>
                    <ConfirmEventDeleteModal />
                    <EventForm />
                    <EventTable />
                </div>
                <div className="w-[95%] mx-auto mb-12 border-b border-gray-400 sm:w-2/5 sm:mb-0 sm:border-b-0 p-[3%]">
                    <h2>News</h2>
                    <ConfirmNewsDeleteModal />
                    <NewsForm />
                    <NewsTable />
                </div>
            </div>

            <div className="bg-white/90 w-[90%] mx-auto my-[3%] flex flex-col sm:flex-row justify-start sm:justify-around">
                <div className="p-[3%]">
                    <div className="flex flex-col justify-center w-full">
                        <h2>Poster</h2>
                        <div className='w-[60%] mx-auto py-2'>
                            <p className='text-center'>Set the <span className='text-red-500'>Featured Event</span> here. To enable a poster, upload the poster with the upload widget, and then click it to open the controls. Then set the poster as active.</p>
                        </div>
                        <PhotoUploadWidget />
                    </div>
                    <div className="managementPosterGallery">
                        <PictureGallery />
                    </div>
                </div>
            </div>

            <div className="bg-white/90 w-[90%] mx-auto my-[3%] flex justify-start" id="documentSection" >
                    <div style={{display: 'flex', justifyContent:'center', flexDirection: 'column', width: '100%' }} className="p-8">
                        <h2>Documents</h2>
                        <div className='w-[60%] mx-auto py-2'>
                            <p className='text-center'><b>Note:</b> A document must have a category assigned to it. If your category does not exist in the drop down, create one in the category section below, then select it. The <b>title</b> of the document is the how you want it to appear on the website as a clickable link.</p>
                            <p className='text-center'>One thing to be aware of, is to name the file appropriately in advance, as this will be the downloaded file name that the user will see. Example: MyDocument.pdf.</p>
                        </div>
                        <div className="formContainer">
                            <DocumentTable />
                            <DocumentForm />
                        </div>
                    </div>
            </div>

            <div className="bg-white/90 w-[90%] mx-auto my-[3%] flex justify-start" id="categorySection" >
                    <div style={{display: 'flex', justifyContent:'center', flexDirection: 'column', width: '100%' }} className="p-8">
                        <h2>Categories</h2>
                        <div className="formContainer">
                            <CategoryTable />
                            <CategoryForm />
                        </div>
                    </div>
            </div>
        </div>
    )
});
